import Home from "@/app/vendors/dashboard/dashboard.page";
import AppointmentList from "@/app/vendors/appointments";
import AppointmentCalendarPage from "@/app/vendors/appointments/calendar.page";
import AppointmentDetail from "@/app/vendors/appointments/appointment-detail.page";
import Individuals from "@/app/vendors/individuals/individuals.page";
import IndividualDetail from "@/app/vendors/individuals/detail";
import Subs from "@/app/vendors/subs/subs.page";
import SubsDetail from "@/app/vendors/subs-detail/subs-detail.page";
import Clients from "@/app/vendors/clients/clients.page";
import ClientDetail from "@/app/vendors/clients-detail/clients-detail.page";
import Services from "@/app/vendors/services/services.page";
import CustomPricingPage from "@/app/vendors/custom-pricing/custom-pricing.page";
import Invoices from "@/app/vendors/invoices/invoices.page";
import InvoiceDetail from "@/app/vendors/invoice-detail/invoice-detail.page";
import ServicesPhotoWorkflow from "@/app/vendors/photo-workflow/photo-workflow.page";
import TaskWorkflow from "@/app/vendors/task-workflow/task-workflow.page";
import ServiceSurveys from "@/app/vendors/surveys/survey.page";
import DailyWorkPage from "@/app/vendors/daily-work/daily-work.page";
import MasterSchedulePage from "@/app/vendors/daily-work/master-schedule.page";
import DailyWorkCalendarPage from "@/app/vendors/daily-work/calendar.page";
import DailyWorkDetail from "@/app/vendors/daily-work/detail";
import PaymentDuesPage from "@/app/vendors/payment-dues/payment-dues.page";

export const vendor_routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/appointments",
    element: <AppointmentList />,
  },
  {
    path: "/appointments/calendar",
    element: <AppointmentCalendarPage />,
  },
  {
    path: "/appointments/:appointmentId",
    element: <AppointmentDetail />,
  },
  {
    path: "/individuals",
    element: <Individuals />,
  },
  {
    path: "/individuals/:individualId",
    element: <IndividualDetail />,
  },
  {
    path: "/subs",
    element: <Subs />,
  },
  {
    path: "/subs/:subsId",
    element: <SubsDetail />,
  },
  {
    path: "/clients",
    element: <Clients />,
  },
  {
    path: "/clients/:clientId",
    element: <ClientDetail />,
  },
  {
    path: "/clients/:clientId/properties/:propertyId",
    element: <CustomPricingPage />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/photo/:id",
    element: <ServicesPhotoWorkflow />,
  },
  {
    path: "/services/task/:id",
    element: <TaskWorkflow />,
  },
  {
    path: "/services/surveys/:id",
    element: <ServiceSurveys />,
  },
  {
    path: "/invoices",
    element: <Invoices />,
  },
  {
    path: "/invoices/:invoiceId",
    element: <InvoiceDetail />,
  },
  {
    path: "/dailywork",
    element: <MasterSchedulePage />,
  },
  {
    path: "/daily-work",
    element: <MasterSchedulePage />,
  },
  {
    path: "/dailywork/contracts",
    element: <DailyWorkPage />,
  },
  {
    path: "/daily-work/contracts",
    element: <DailyWorkPage />,
  },
  {
    path: "/dailywork/calendar",
    element: <DailyWorkCalendarPage />,
  },
  {
    path: "/daily-work/calendar",
    element: <DailyWorkCalendarPage />,
  },
  {
    path: "/dailywork/:dailyWorkId",
    element: <DailyWorkDetail />,
  },
  {
    path: "/daily-work/:dailyWorkId",
    element: <DailyWorkDetail />,
  },
  {
    path: "/payment-dues",
    element: <PaymentDuesPage />,
  },
];
